import React from 'react';
import { Box, Tabs, Tab, AppBar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { TabPanel, a11yProps } from './tabPanel';

// const tabStyle = {pl: 0, pr: 0}
const CustomTabs = (props) => {
    const theme = useTheme();
    const renderComponent = (tab, parentprops) => {
        if (parentprops.snackBarProps && parentprops.setSnackBarProps) {
            return React.createElement(tab.component, {
                data: tab.data && tab.data.length > 0 ? tab.data : [],
                snackBarProps: parentprops.snackBarProps
                    ? parentprops.snackBarProps
                    : null,
                setSnackBarProps: parentprops.setSnackBarProps
                    ? parentprops.setSnackBarProps
                    : null,
                getParticipants: parentprops.getParticipants
                    ? parentprops.getParticipants
                    : null,
                modPermission: parentprops.modPermission
                    ? parentprops.modPermission
                    : null,
                getSentData: parentprops.getSentData
                    ? parentprops.getSentData
                    : null,
                sentData: parentprops.sentData
                    ? parentprops.sentDcheckUsersata
                    : null,
            });
        } else if (parentprops.checkUsers) {
            return React.createElement(tab.component, {
                data: tab.data && tab.data.length > 0 ? tab.data : [],
                checkUsers: parentprops.checkUsers,
                selectedUsers: parentprops.selectedUsers
                    ? parentprops.selectedUsers
                    : null,
                handleAllCheck: parentprops.handleAllCheck,
                searchUsers: parentprops.searchUsers
                    ? parentprops.searchUsers
                    : null,
            });
        } else {
            return React.createElement(tab.component, {
                data: tab.data && tab.data.length > 0 ? tab.data : [],
            });
        }
    };

    return (
        <Box
            sx={
                props.removeMargin != undefined && props.removeMargin
                    ? { width: '100%', mb: 0 }
                    : { width: '100%', mt: 2, mb: 0 }
            }>
            {props.fixedTabs ? (
                <AppBar position="sticky">
                    <Tabs
                        value={props.value}
                        onChange={(event, newValue) =>
                            props.handleChange(newValue)
                        }
                        textColor="#fff"
                        indicatorColor="secondary"
                        aria-label="secondary tabs example"
                        {...props}>
                        {props.data.map((tab, index) => (
                            <Tab
                                key={`tab_${index}`}
                                value={index}
                                label={tab.label}
                                aria-label={tab.label}
                                sx={{
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    '&.Mui-selected': {
                                        color: '#fff',
                                    },
                                    textTransform: 'capitalize',
                                }}
                                {...a11yProps(tab.label.toLowerCase())}
                            />
                        ))}
                    </Tabs>
                </AppBar>
            ) : (
                <Tabs
                    value={props.value}
                    onChange={(event, newValue) => props.handleChange(newValue)}
                    // textColor="#fff"
                    indicatorColor="secondary"
                    aria-label="secondary tabs example"
                    {...props}>
                    {props.data.map((tab, index) => (
                        <Tab
                            key={`tab_${index}`}
                            value={index}
                            label={tab.label}
                            aria-label={tab.label}
                            sx={
                                props.fixedTabs
                                    ? {
                                          color: 'rgba(255, 255, 255, 0.6)',
                                          '&.Mui-selected': {
                                              color: '#fff',
                                          },
                                          textTransform: 'capitalize',
                                      }
                                    : {
                                          textTransform: 'capitalize',
                                      }
                            }
                            {...a11yProps(tab.label.toLowerCase())}
                        />
                    ))}
                </Tabs>
            )}
            {props.data.map((tab, index) => (
                <TabPanel
                    key={`panel_${index}`}
                    value={props.value}
                    index={index}
                    dir={theme.direction}>
                    {renderComponent(tab, props)}
                </TabPanel>
            ))}
        </Box>
    );
};

export default CustomTabs;
